import { domReady } from './utils.js';

async function init() {
  await domReady();

  document.querySelectorAll('.shopify-app-block[id*="klaviyo"]').forEach(async (wrapper) => {
    let form = wrapper.querySelector('form.klaviyo-form');
    if (form) {
      removeStyles(form);
    }
    else {
      const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          if (mutation.type === 'childList') {
            // observer.disconnect();
            setTimeout(() => {
              const form = wrapper.querySelector('form.klaviyo-form');
              if (form) {
                removeStyles(form);
              }
            }, 10);
          }
        });
      });

      // Start observing
      observer.observe(wrapper, {
        childList: true,
        subtree: true
      });
    }
  });
}

function removeStyles(form) {
  form.removeAttribute('style');

  form.querySelectorAll('p, label, h1, h2, h3, h4,h5, h6, span').forEach((el) => {
    let removeStyles = true;

    const isConsentLabel = el.getAttribute('for')?.includes('consent');
    if (isConsentLabel) {
      removeStyles = false;
    }

    if (removeStyles) {
      el.removeAttribute('style');
    }

    // el.querySelectorAll('*').forEach((child) => child.removeAttribute('style'));

    if (['LABEL'].includes(el.tagName)) {
      if (!el.getAttribute('for').includes('consent')) {
        el.className = '';
        el.classList.add('text-tagline-sm', 'text-medium');
      }
    }
    if (el.tagName === 'SPAN' && el.textContent === '✦') {
      el.style.color = 'var(--color-brand-1)';
    }
  });

  form.querySelectorAll('*').forEach((el) => {
    if (el.style.fontSize) {
      el.style.fontSize = null;
    }
  });
}

init();
